// @flow

export type { PaymentMethod, PaymentMethodCode } from './types';
export { getCode as getPaymentMethodCode } from './get-code';
export { isVoucher } from './is-voucher';
